import * as React from "react";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { leagueClientSkin } from "../skins/league-client";
import { riotProductSkin } from "../skins/riot-product";
import styled from "styled-components";
import { CoveredCard, CardImage, CardBody, CardTitle } from "../../../components/Card";
import { ContentEngagement } from "../../../components/ContentEngagement";
import { generateContentAnalytics } from "../../../functional/analyticsUtils";
import { AspectRatio } from "../../../components/AspectRatio";
import { Media } from "../../../components/Media";
import { Icon } from "../../../components/Icon";
const StylableArticleCoveredCard = ({ content, ...htmlProps }) => {
    const { media, title, action, shortTitle } = content;
    return (React.createElement(ContentEngagement, { contentAnalytics: generateContentAnalytics(content, "ArticleCoveredCard"), action: action, tabIndex: 0, "data-testid": "article-covered-card-engagement" },
        React.createElement(AspectRatio, { ratio: 16 / 9 },
            React.createElement(CoveredCard, { ...htmlProps },
                React.createElement(CardImage, null,
                    React.createElement(Media, { media: media })),
                action?.type === "youtube_video" && React.createElement(Icon, { name: "action-play-video" }),
                action?.type === "weblink" && React.createElement(Icon, { name: "link" }),
                React.createElement(CardBody, null, title && React.createElement(CardTitle, null, shortTitle ? shortTitle : title))))));
};
StylableArticleCoveredCard.defaultProps = {
    "data-testid": "articlecoveredcard-component",
};
export const ArticleCoveredCard = styled(StylableArticleCoveredCard) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.LeagueClient]: leagueClientSkin,
})}
`;
//# sourceMappingURL=ArticleCoveredCard.js.map